export default "/images/red_x.svg"